
function Globalpresence() {
    return (



        <section>
            <div className="container">
                <div className="text-center heading-center">
                <div class="text-center mb-5"><h2 class="heading text-center ">Global <span>Presence</span></h2></div>
                </div>
                <div className="contact-office">
                    <ul className="ofc-location">
                        <li><a href="#uae" data-anchor="relativeanchor">UNITED ARAB EMIRATES
                        </a></li>

                        <li><a href="#NewYork" data-anchor="relativeanchor">UNITED STATE OF AMERICA</a>
                        </li>
                        <li><a href="#SouthAfrica" data-anchor="relativeanchor">SOUTH AFRICA</a>
                        </li>

                        <li><a href="#SINGAPORE" data-anchor="relativeanchor">SINGAPORE</a>
                        </li>
                        <li><a href="#INDONESIA" data-anchor="relativeanchor">INDONESIA</a>
                        </li>
                        
                        <li><a href="#INDIA" data-anchor="relativeanchor">INDIA</a></li>
                        <li><a href="#AUSTRALIA" data-anchor="relativeanchor">AUSTRALIA</a>
                        </li>
                        <li><a href="#CANADA" data-anchor="relativeanchor">CANADA</a></li>
                        <li><a href="#NETHERLANDS"
                            data-anchor="relativeanchor">NETHERLANDS</a></li>
                        <li><a href="#BENIN" data-anchor="relativeanchor">BENIN</a></li>
                        <li><a href="#HONG-KONG" data-anchor="relativeanchor">HONG KONG</a>
                        </li>
                        <li><a href="#MAURITIUS" data-anchor="relativeanchor">MAURITIUS</a>
                        </li>
                        <li><a href="#TOGO" data-anchor="relativeanchor">TOGO</a></li>
                        <li><a href="#MOZAMBIQUE"
                            data-anchor="relativeanchor">MOZAMBIQUE</a></li>
                        <li><a href="#Madagascar"
                            data-anchor="relativeanchor">MADAGASCAR </a></li>
                    </ul>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="location-block fadeInLeft wow" id="uae">
                            <img src="images/united-arab-emirates.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">UNITED ARAB EMIRATES</h2>
                            <h3 className="sub-heading">RBK INTERNATIONAL GENERAL TRADING CO LLC</h3>
                            <p><i className="fas fa-phone"></i><a href="tel:+971 4 55902 54 "> +971 4 55902 54 </a>  |  <a href="tel:+971 5 08792 799"> +971 5 08792 799</a> </p>
                            <p> <a href="mailto:info@rbkinternational.ae"><i className="fas fa-envelope"></i>
                                info@rbkinternational.ae</a></p>
                            <p> <a href="http://rbkinternational.ae"><i className="fas fa-globe"></i>
                                rbkinternational.ae</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/nW66HSuqBAuRANsUA">Office 25, 18th Floor Burlington Tower
                                Business Bay Dubai
                                United Arab Emirates
                            </a></p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInDown wow" data-wow-delay="0.2s" id="NewYork">
                            <img src="images/united-states-of-america.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">UNITED STATE OF AMERICA</h2>
                            <h3 className="sub-heading">RBK International USA LLC</h3>

                            <p><i className="fas fa-phone"></i> <a href="tel:+1(929)563-6077"> +1(929)563-6077</a> | <a
                                href="tel:+1(585)437-0967">+1(585)437-0967</a> </p>
                            <p> <a href="mailto:info@rbkinternational.us"><i className="fas fa-envelope"></i>
                                info@rbkinternational.us</a></p>
                            <p> <a href="www.rbkinternational.us"><i className="fas fa-globe"></i>
                                www.rbkinternational.us</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a
                                href="https://goo.gl/maps/2mDwSPhfWCLe2bKB6">RBK International USA LLC<br />
                                244 5th Ave, Suite # R235
                                New York, NY 10001
                                United State
                            </a></p>

                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="location-block fadeInDown wow" data-wow-delay="0.2s" id="SouthAfrica">
                            <img src="images/south-africa.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">SOUTH AFRICA</h2>
                            <h3 className="sub-heading">RBK International South Africa Pty Ltd</h3>
                            <p><i className="fas fa-phone"></i> <a
                                href="tel:+27 738237502">+27 738237502</a> </p>
                            <p> <a href="mailto:southafrica@rbkinternational.com"><i className="fas fa-envelope"></i>
                                southafrica@rbkinternational.com</a></p>
                            <p> <a href="http://rbkinternational.co.za"><i className="fas fa-globe"></i>
                                http://rbkinternational.co.za</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a
                                href="https://goo.gl/maps/2YAEVK4RhUFrZkRZ7">RBK International South Africa Pty Ltd<br />
                                PO Box 15829 LYTTELION
                                Centurion , Gauteng, 0140
                                Republic of South Africa</a></p>

                        </div>
                    </div>



















                    <div className="col-lg-6">
                        <div className="location-block fadeInDown wow" data-wow-delay="0.2s" id="SINGAPORE">
                            <img src="images/singapore.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">SINGAPORE</h2>
                            <h3 className="sub-heading">RBK International (SG) Pte Ltd</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+65 69783899"> +65 69783899</a> | <a
                                href="tel:+65 84070759">+65 84070759</a> </p>
                            <p> <a href="mailto:info@rbkinternational.com.sg"><i className="fas fa-envelope"></i>
                                info@rbkinternational.com.sg</a></p>
                            <p> <a href="http://www.rbkinternational.com.sg/"><i className="fas fa-globe"></i>
                                www.rbkinternational.com.sg</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/kx94W3tz3SnKKQZS7">10 Anson Road,
                                #22-02 International Plaza
                                Singapore 079903.
                            </a></p>

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="INDONESIA">
                            <img src="images/indonesia.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">INDONESIA</h2>
                            <h3 className="sub-heading">PT RBK International Indonesia</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+62 219601505"> +62 219601505</a> | <a
                                href="tel:+62 82252549696"> +62 82252549696</a> </p>
                            <p> <a href="mailto:info@rbkinternational.id"><i className="fas fa-envelope"></i>
                                info@rbkinternational.id</a></p>

                            <p> <a href="http://www.rbkinternational.id/"><i className="fas fa-globe"></i>
                                www.rbkinternational.id</a></p>


                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://g.page/rbkindonesia?share">Gedung Menara Rajawali, lantai 7, Jl. Mega Kuningan Lot 5.1,
                                kawasan mega kuningan, Kel. Kuningan Timur, Kec. Setiabudi,
                                Kota Adm. Jakarta Selatan, Prov. DKI Jakarta
                            </a></p>

                        </div>
                    </div>

                    

                    <div className="col-lg-6">
                        <div className="location-block fadeInDown wow" data-wow-delay="0.2s" id="INDIA">
                            <img src="images/india.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">INDIA</h2>
                            <h3 className="sub-heading">RBK Industries Limited</h3>
                            <p><i className="fas fa-phone"></i>  <a
                                href="tel:+91 2029527909"> +91 2029527909</a></p>
                            <p> <a href="mailto:info@rbkindustriesltd.com"><i className="fas fa-envelope"></i>
                                info@rbkindustriesltd.com</a></p>
                            <p> <a href="http://www.rbkindustriesltd.com/"><i className="fas fa-globe"></i>
                                www.rbkindustriesltd.com </a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://g.page/rbk-industries-limited?share">#114, Platinum Square,
                                Near Hyatt Regency, Viman Nagar,
                                Pune, Maharashtra, India
                            </a></p>

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="AUSTRALIA">
                            <img src="images/Australia.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">AUSTRALIA</h2>
                            <h3 className="sub-heading">RBK International (Australia) Pty Ltd</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+61283810677"> +61283810677</a> </p>
                            <p> <a href="mailto:info@rbkinternational.net.au"><i className="fas fa-envelope"></i>
                                info@rbkinternational.net.au </a></p>
                            <p> <a href="http://www.rbkinternational.net.au/"><i className="fas fa-globe"></i>
                                www.rbkinternational.net.au </a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://g.page/rbk-international-australia-pt?share">66 Bermbing Street
                                The Ponds NSW 2769 Sydney,
                                Australia.
                            </a></p>

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="CANADA">
                            <img src="images/canada.png" className="img-fluids" alt="Logo" />

                            <h2 className="sub-heading">CANADA</h2>
                            <h3 className="sub-heading">RBK Global Canada Limited</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+1-647-493-7477"> +1-647-493-7477</a>  </p>
                            <p> <a href="mailto:info@rbkglobal.ca"><i className="fas fa-envelope"></i>
                                info@rbkglobal.ca</a></p>
                            <p> <a href="http://rbkglobal.ca"><i className="fas fa-globe"></i>
                                rbkglobal.ca</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/Dae83bJH2qAw5rCG6"> Willowmount DR
                                Toronta ON M1L 1Y1
                                Canada
                            </a></p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="NETHERLANDS">
                            <img src="images/netherlands.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">NETHERLANDS</h2>
                            <h3 className="sub-heading">RBK International Netherlands B.V.</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+31 (0) 132 200 079"> +31 (0) 132 200 079</a> |
                                <a href="tel:+31-68-430-4105"> +31-68-430-4105</a> </p>
                            <p> <a href="mailto:info@rbkinternational.nl"><i className="fas fa-envelope"></i>
                                info@rbkinternational.nl</a></p>
                            <p> <a href="http://www.rbkinternational.nl/"><i className="fas fa-globe"></i>
                                www.rbkinternational.nl</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/cWHL62xGvJ5cgNZJ6">Gustav Mahlerplein
                                2,1082 MA, AmsterdamThe
                                Netherlands</a></p>

                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="BENIN">
                            <img src="images/benin.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">BENIN </h2>
                            <h3 className="sub-heading">RBK International Benin SARL</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+229 53009905"> +229 53009905</a> | <a
                                href="tel:+229 52700005">+229 52700005</a> </p>
                            <p> <a href="mailto:info@rbkinternational.com.bj"><i className="fas fa-envelope"></i>
                                info@rbkinternational.com.bj</a></p>
                            <p> <a href="http://www.rbkinternational.com.bj/"><i className="fas fa-globe"></i>
                                www.rbkinternational.com.bj</a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/5a4XbCPTnhsVRLyw8">Littoral , Cotonou
                                11th Arrondissement ,
                                Gbegamey
                                TF 535 , A Maison Yamadjako Immaculee.
                            </a></p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="HONG-KONG">
                            <img src="images/hong-kong.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">HONG KONG</h2>
                            <h3 className="sub-heading">RBK Global (HK) Limited</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+85235496513 "> +85235496513 </a> | <a
                                href="tel:+85294105677">+85294105677 </a> </p>
                            <p> <a href="mailto:info@rbkinternational.com.hk"><i className="fas fa-envelope"></i>
                                info@rbkinternational.com.hk</a></p>
                            <p> <a href="http://www.rbkinternational.com.hk/"><i className="fas fa-globe"></i>
                                www.rbkinternational.com.hk </a></p>

                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/JVzHSFre6iYPRz388">Unit 609, 6/GF
                                Hong Kong Plaza 188
                                Connaught Road West
                                Hong Kong.
                            </a></p>
                        </div>
                    </div>


                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="MAURITIUS">
                            <img src="images/mauritius.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">MAURITIUS</h2>
                            <h3 className="sub-heading">RBK International Mauritius Ltd</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+230 58947748">  +230 58947748 </a> </p>
                            <p> <a href="mailto:info@rbkinternational.com.mu"><i className="fas fa-envelope"></i>
                                info@rbkinternational.com.mu</a></p>
                            <p> <a href="http://www.rbkinternational.com.mu/ "><i className="fas fa-globe"></i>
                                www.rbkinternational.com.mu </a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/3eHv38fJenxya9qs5">Freeport Operations (Mauritius) Limited,
                                Freeport Zone 7, Mer-Rouge, 1112-07
                                Mauritius.
                            </a></p>
                        </div>
                    </div>


                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="TOGO">
                            <img src="images/togo.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">TOGO</h2>
                            <h3 className="sub-heading">RBK INTERNATIONAL TOGO SARL</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+228 93527224 "> +228 93527224  </a> </p>
                            <p> <a href="mailto:togo@rbkinternational.com"><i className="fas fa-envelope"></i>  togo@rbkinternational.com
                            </a></p>
                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/JH9RDMb4FjxNZifR8">Rue AFLAO GAKLI,
                                AGBALEPEDOGAN,
                                LOME, TOGO, 13 BP 589
                            </a></p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="MOZAMBIQUE">
                            <img src="images/mozambique.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">MOZAMBIQUE</h2>
                            <h3 className="sub-heading">RBK INTERNATIONAL MOZAMBIQUE LIMITADA</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+258 84 601 9260 "> +258 84 601 9260  </a> </p>
                            <p> <a href="mailto:Mozambique@rbkinternational.com"><i className="fas fa-envelope"></i>
                                Mozambique@rbkinternational.com
                            </a></p>

                            <p><i className="fas fa-map-marker-alt"></i> <a href="#!">  MOHAMOD ASSIF ZACARIS IDRIS
                                MOZAMBIQUE</a></p>


                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="location-block fadeInRight wow" data-wow-delay="0.3s" id="Madagascar">
                            <img src="images/madagascar.png" className="img-fluids" alt="Logo" />
                            <h2 className="sub-heading">MADAGASCAR</h2>
                            <h3 className="sub-heading">RBK INTERNATIONAL MADAGASCAR LTD</h3>
                            <p><i className="fas fa-phone"></i> <a href="tel:+261349889536 "> +261349889536 </a> </p>
                            <p> <a href="mailto:madagascar@rbkinternational.com"><i className="fas fa-envelope"></i>
                                madagascar@rbkinternational.com
                            </a></p>

                            <p><i className="fas fa-map-marker-alt"></i> <a href="https://goo.gl/maps/LaMKnWxVwyy7GdDA8">LOT 583 RDC 67 HA
                                Centre Quest
                                Antananarivo Madagascar</a></p>


                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}
export default Globalpresence;